export default "__VITE_ASSET__87c2ed15__"